import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=2a2cd90e&scoped=true"
import script from "./my-order.vue?vue&type=script&lang=js"
export * from "./my-order.vue?vue&type=script&lang=js"
import style0 from "./my-order.vue?vue&type=style&index=0&id=2a2cd90e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_webpack@5.106.2__lodash@4.17.21__7d4c8351301cd9d6db661abdd84ad76e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2cd90e",
  null
  
)

export default component.exports